import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Flex,
  Text,
  useToast,
} from '@chakra-ui/react';
import React from 'react';

import {
  errorToastAdminConfig,
  errorToastId,
  successToastConfig,
} from 'packages/common-frontend/constants';
import {
  GET_CREDIT_AGREEMENT_DOCUMENTS_METADATA,
  IS_CREDIT_AGREEMENT_WIP_UNLOCKED,
} from 'packages/creditAgreements/requests/requests.gql';
import { useRemoveCreditAgreementFullArtifactMutation } from 'packages/creditAgreements/requests/requests.gql.generated';

/**
 * NOTE: Permissioned for lender and admin dash CA configuration
 */

export const RemoveCreditAgreementModal: React.FC<{
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  creditFacilityId: string;
  committedFutureRevisionId: string;
}> = ({ setIsOpen, isOpen, committedFutureRevisionId, creditFacilityId }) => {
  const toast = useToast();

  const [
    removeCreditAgreementFullArtifact,
    { loading: removeCreditAgreementFullArtifactLoading },
  ] = useRemoveCreditAgreementFullArtifactMutation({
    onCompleted: () => {
      if (!toast.isActive(successToastConfig.id)) {
        successToastConfig.title =
          'Successfully removed credit agreement document.';
        toast(successToastConfig);
      }
    },
    refetchQueries: [
      {
        query: GET_CREDIT_AGREEMENT_DOCUMENTS_METADATA,
        variables: { creditFacilityId },
      },
      {
        query: IS_CREDIT_AGREEMENT_WIP_UNLOCKED,
        variables: { creditFacilityId },
      },
    ],
    onError: () => {
      if (!toast.isActive(errorToastId)) {
        errorToastAdminConfig.title = `Error removing credit agreement document.`;
        toast(errorToastAdminConfig);
      }
    },
  });

  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <ModalOverlay />
      <ModalContent padding="20px">
        <ModalHeader>Remove Credit Agreement</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text mb="8">
            Please confirm credit agreement removal. This cannot be undone.
          </Text>
          <Flex justifyContent="space-between">
            <Button
              onClick={() => setIsOpen(false)}
              marginLeft={3}
              aria-label="Cancel"
            >
              Cancel
            </Button>
            <Button
              isLoading={removeCreditAgreementFullArtifactLoading}
              onClick={() => {
                removeCreditAgreementFullArtifact({
                  variables: {
                    creditFacilityId,
                    creditAgreementId: committedFutureRevisionId,
                  },
                });
              }}
              variant="ghost"
              marginLeft={3}
              aria-label="Remove"
            >
              Remove
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
